import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@ooh/screens';
import { unreadCountQueryOptions } from '../api/queries';

/**
 * Polls the unread notification count every 30 seconds.
 * Pauses polling when the document tab is hidden (refetchIntervalInBackground: false).
 *
 * Must be called from a component inside `AppUiProvider`.
 *
 * Traceability: spec.md:249–253 — "Polling pauses when document is hidden"
 * REQ-10.2 → In-App Notification Surface In Web Header
 */
export function useUnreadCount() {
  return useQuery(unreadCountQueryOptions(useApiClient()));
}
